export const forwarding_types = {
  AUDIO: 'AUDIO',
  QUEUE: 'QUEUE',
  EXTENSION: 'EXTENSION',
  GENERIC_EXTENSION: 'GENERIC_EXTENSION',
  RING_GROUP: 'RING_GROUP'
};
